
import React from "react";

class PasswordStrengthMeter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            strength: 0,
            strengthMessage: ''
        };
    }

    componentDidMount() {
        this.calculateStrength(this.props.password);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.password !== this.props.password) {
            this.calculateStrength(this.props.password);
        }
    }

    calculateStrength = (password) => {
        const lowerCaseRegex = /[a-z]/;
        const upperCaseRegex = /[A-Z]/;
        const numericRegex = /[0-9]/;
        const specialCharRegex = /[^A-Za-z0-9]/;

        // Calculate the overall strength
        let count = 1;
        const total = 4;

        if (password.length >= 8) {
            count++
        }

        if (lowerCaseRegex.test(password) && upperCaseRegex.test(password) && numericRegex.test(password) && specialCharRegex.test(password)) {
            count+=2
        }

        const overallStrength = (count / total) * 100;
        this.setState({ strength: overallStrength });

        this.setState({ strengthMessage: this.getPasswordStrengthText(count) });
    };

    getPasswordStrengthText = (score) => {
        switch (score) {
            case 0:
                return 'Very Weak';
            case 1:
                return 'Weak';
            case 2:
                return 'Fair';
            case 3:
                return 'Good';
            case 4:
                return 'Strong';
            default:
                return '';
        }
    };

    getColor = (strength) => {
        if (strength < 30) return 'red';
        if (strength < 60) return 'orange';
        if (strength < 90) return 'yellow';
        return 'green';
    };

    render() {
        const { strength, strengthMessage } = this.state;
        return (
            <div style={{ paddingTop: '2px', width: '100%', marginBottom: '2px' }}>
                <div
                    style={{
                        width: `${strength}%`,
                        backgroundColor: this.getColor(strength),
                        borderRadius: '20px',
                        height: '4px',
                    }}
                    aria-valuenow={strength}
                    aria-valuemin="0"
                    aria-valuemax="100"
                />
                <div style={{ display: 'flex', justifyContent: 'end', margin: '0' }}>
                    <p style={{ color: '#6c757d', margin: '0' }}>{strengthMessage}</p>
                </div>
            </div>
        );
    }
}

export default PasswordStrengthMeter